import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MeinBereichPaper, MeinBereichButton } from '../../../../components/ui-component/mein-bereich/MeinBereichComponents';
import SettingsIcon from '@mui/icons-material/Settings';

function EInstellung() {
	const navigate = useNavigate();
	return (
		<>
			<MeinBereichPaper titleIcon={<SettingsIcon />} title={'Einstellung'}>
				<MeinBereichButton buttonName="Meine Daten verwalten" onClick={() => navigate('/mein-bereich/mein-profil')} />
				<MeinBereichButton
					buttonName="Angaben zur Organisation verwalten"
					onClick={() => navigate('/mein-bereich/meine-organisation')}
				/>
			</MeinBereichPaper>
		</>
	);
}

export default EInstellung;
